export default "__VITE_ASSET__33446661__"